import { call, put, takeLatest, select } from 'redux-saga/effects';
import pickBy from 'lodash/pickBy';
import { get } from 'lodash';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { getSortParams } from '../helpers/utils';
import { FETCH_INVOICES, FETCH_INVOICES_FAIL, FETCH_INVOICES_SUCCESS } from '../redux/Invoices';
import { SET_LOADER } from '../redux/Loader';

function* fetchInvoicesFlow() {
  try {
    yield put(SET_LOADER({ value: true, }));
    const sortData = yield select((state) => get(state, ['tables', 'invoices', 'sort']));
    const queryValue = yield select((state) => get(state, ['tables', 'invoices', 'queryValue']));
    const limitValue = yield select((state) => get(state, ['tables', 'invoices', 'rowsPerPage']));
    const page = yield select((state) => get(state, ['tables', 'invoices', 'page']));
    const params = pickBy(
      {
        ...getSortParams(sortData),
        query: queryValue,
        limit: limitValue,
        page,
      },
      (val) => Boolean(val)
    );

    const endpoint = `${apiRoot}/invoices`;
    const data = yield call(apiCall, { method: 'GET', endpoint, params, });
    yield put(FETCH_INVOICES_SUCCESS(data));
  } catch (error) {
    yield put(FETCH_INVOICES_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* FetchInvoices() {
  yield takeLatest(FETCH_INVOICES, fetchInvoicesFlow);
}
